var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-rankfollow",on:{"click":_vm.handleFollow}},[(!_vm.status)?_c('div',{staticClass:"com-rankfollow-no flex ai-c jc-c"},[_c('div',{staticClass:"com-rankfollow-no-icon"}),_c('div',[_vm._v("关注")])]):_c('div',{staticClass:"com-rankfollow-yes"},[_vm._v("已关注")])])
}
var staticRenderFns = []

export { render, staticRenderFns }